import React, { Children, ReactNode } from 'react';
import classNames from 'classnames';

export interface FieldProps {
  className?: string;
  name: string;
  children: ReactNode;
  id?: string;
}

const Field = ({ className, name, children, id }: FieldProps): JSX.Element => (
  <div id={id} className={classNames('ver-field-group__field', className)}>
    <dt className="ver-field-group__field-name">{name}</dt>
    {Children.map(children, (child) => (
      <dd className="ver-field-group__field-value">{child}</dd>
    ))}
  </div>
);

export default Field;
